import React from "react";
import { CompanySelect } from "../../components/companySelect/companySelect.component";

export const CompanySelectPage = () => {
  return <CompanySelect />;
};
